export const ASSESSMENT_SUMMARY_FEATURE_NAME = 'assessmentSummary';
export const VALORATION_HOME_FEATURE_NAME = 'valorationHome';

export const WITHOUT_AUTOASSESSMENT = 0,
  ZERO_AUTO_ASSESSMENT_KEYS = 0,
  VALORATION_TRUE_STATE = 0,
  TEAM_PRAGMAPOWER_INDEX = 0,
  SENIORITY_SCORE_INDEX_ZERO = 0,
  SENIORITY_LEVEL_ZERO = 0,
  DEFAULT_ACHIEVEMENTS_POINTS = 0,
  INITIAL_SCORE = 0;

export const SELF_ASSESSED_TRUE_STATE = 1,
  INITIAL_SENDED_STAGE = 1,
  SENIORITY_SCORE_INDEX_ONE = 1,
  DEFAULT_SENIORITY_SCORE = 1;

export const COMMENTS_LOADED_STATE = true;
export const COMMENTS_LOADING_STATE_FALSE = false;
export const COMMENTS_INITIAL_LOADING_STATE = true;

export const ID_ASSESSMENT_INITIAL = -1;

export const ASSESMENT_GENERATE_REPORT_SCORE_FORMAT = '1.0-1',
  NUMBER_FORMAT_ONE_DECIMAL = '1.0-1';

export const PRAGMAPOWER_MIN_VALORATION = 3;
export const PRAGMAPOWER_NOT_EVALUATED = 999;
export const TEAM_PRAGMAPOWER_STRING = 'Team Pragmapower';

export const SENIORITY_LEVEL_TOOLTIP_PROGRESSIVE_TITLE = 'Puntaje por nivel';
export const SENIORITY_LEVEL_TOOLTIP_HORIZONTAL_TITLE = 'Puntaje por seniority';
export const SENIORITY_LEVEL_TOOLTIP_PROGRESSIVE = 'Calificación  progresiva';
export const SENIORITY_LEVEL_TOOLTIP_HORIZONTAL = 'Calificación  horizontal';
export const SENIORITY_LEVEL_TOOLTIP_PROGRESSIVE_DESCRIPTION =
  'Para avanzar al siguiente seniority, se debe alcanzar el puntaje mínimo indicado y dominar el 100% de los comportamientos CORE del nivel correspondiente.';
  //'El seniority se supera acumulando los puntos de los niveles anteriores más los requeridos en este nivel.';

export const CORE_BEHAVIOR_DDESCRIPTION =
  'El nivel dependerá del porcentaje de cumplimiento de los comportamientos <span class="core"">CORE</span> (comportamientos obligatorios):';

export enum SCORES_SUMS {
  zero = 0,
  one = 1,
  two = 2,
  three = 3,
  four = 4,
  five = 5,
  six = 6,
  seven = 7,
  eight = 8,
  nine = 9,
  ten = 10,
  one_hundred = 100,
  two_point_nine = 2.9,
  three_point_five = 3.5,
  three_point_six = 3.6,
  three_point_nine = 3.9,
}
